import { configureStore } from '@reduxjs/toolkit';
import settingsSlice from './slices/settingsSlice';
import componentSlice from './slices/componentSlice';
import clientSlice from "./slices/clientSlice";
import refreshSlice from './slices/refreshSlice';
import clientTransferSlice from './slices/clientTransactionSlice';
import { useDispatch, useSelector } from 'react-redux';
import InboxSlice from './slices/inboxSlice';

const store = configureStore({
  reducer: {
    settings: settingsSlice.reducer,
    component: componentSlice.reducer,
    client: clientSlice.reducer,
    refresh: refreshSlice.reducer,
    clientTransfer: clientTransferSlice.reducer,
    inboxSettings: InboxSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({}).concat(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export default store;
